import { render, staticRenderFns } from "./SettingUserDetail.vue?vue&type=template&id=88450ca6&scoped=true&"
import script from "./SettingUserDetail.vue?vue&type=script&lang=js&"
export * from "./SettingUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./SettingUserDetail.vue?vue&type=style&index=0&id=88450ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88450ca6",
  null
  
)

export default component.exports